import { gqlFetchList } from 'app/lib/graphqlClient'
import { logError } from 'lib/logging'

type StaffMembersResult = {
  hits: { id: string; name: string }[]
  total: number
  page: number
}

/**
 * Fetches staff members via the GraphQL `staffMembers` query.
 * Replaces the deprecated REST endpoints `/api/staff` and `/api/users/{wid}/staff`.
 *
 * The query is automatically scoped to the authenticated user's workspace.
 * Used by ComboAsync, FormComboAsyncV2, and filter columns for staff typeahead dropdowns.
 *
 * @param params.query - Search text to filter staff by name
 * @returns Staff list with `{ hits, total, page }` shape compatible with ComboAsync optionsMapper
 */
export async function staffMembersFetcher(params: {
  query: string
  [key: string]: string | undefined
}): Promise<StaffMembersResult> {
  try {
    return await gqlFetchList<{ id: string; name: string }>(
      'staffMembers',
      { search: params.query || undefined, pagination: { limit: 100 } },
      'id name',
    )
  } catch (err) {
    logError('staffMembersFetcher failed', err)
    return { hits: [], total: 0, page: 0 }
  }
}
